export default __webpack_public_path__ + "static/media/Armguards of the Black Pharaoh.63619a51.jpg";